// @flow
import { post, get, put, destroy } from '../../utils/fetch'

export type CommentType = 'sound' | 'album' | 'comment'

export const getComments = async (
  type: string,
  id: string,
  perPage: number,
  page: number,
) => {
  const result = await get(
    `/comments/${type}/${id}?perPage=${perPage}&page=${page}`,
  )
  return result
}

export const addComment = async (type: string, id: string, text: string) => {
  const result = await post(`/comments/create/${type}/${id}`, { text })
  return result
}

export const updateComment = async (id: string, text: string) => {
  const result = await put(`/comments/${id}`, { text })
  return result
}

export const deleteComment = async (id: string) => {
  const result = await destroy(`/comments/${id}`)
  return result
}

export type ReactionType =
  | 'plus'
  | 'minus'
  | 'Laugh'
  | 'Hooray'
  | 'Confused'
  | 'Heart'

export const addReaction = async (reaction: ReactionType, id: string) => {
  const result = await post(`/comments/reaction/${id}`, { reaction })
  return result
}
